import React, { Component } from 'react'
import style from './style.css'

let MarginTop = 0
export function Configure(info) {
    MarginTop = info
}

export class PagePoint extends Component {

    
    componentDidMount() {
    
        this.scroll = function() {
            let el = document.getElementsByName(`pagepoint__${this.props.name}`)[0]
            var element = document.documentElement || document.body


            let top = element.scrollTop + MarginTop
            let start = el.offsetParent.offsetTop + el.offsetTop
            let end = start + el.clientHeight

            // console.log(`TOP: ${top}`)
            // console.log(`Start: ${start}`)
            // console.log(`End: ${end}`)
            // if((element.scrollTop + 80) >= el.offsetTop && (element.scrollTop + 80) <= (el.offsetTop + el.clientHeight)) {
            //     if(this.props.handleOn) {
            //         this.props.handleOn(this.props.name)
            //     } 
            // }

            
            // console.log(this.props.name)

            if((top+20) >= start && (top -20) <= end && this.props.handleOn) {
                // console.log(this.props.name)
                // console.log(`TOP: ${top}`)
                // console.log(`Start: ${start}`)
                // console.log(`End: ${end}`)
                this.props.handleOn(this.props.name)
            }


        }.bind(this)

        window.addEventListener('scroll', this.scroll)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scroll)
    }

    render() {
        return (
            <span style={{...this.props.style}} className={style.box} name={`pagepoint__${this.props.name}`}>{this.props.children}</span>
        )
    }
}

export class ScrollTo extends Component {
    render() {
        return (
            <span onClick={() => GoTo(this.props.location)}>
                {this.props.children}
            </span>
        )
    }
}

export const GoTo = (location) => {
    let el = document.getElementsByName(`pagepoint__${location}`)[0]
    let start = el.offsetParent.offsetTop + el.offsetTop - MarginTop

    var element = document.documentElement || document.body
    element.scrollTop = start
}


// WEBPACK FOOTER //
// ./src/components/atoms/HashLink/index.js